import { FC } from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';

import { StoreI } from '~src/rootReducer';
import { NotificationI } from '~src/store/app/interfaces';
import { removeNotification } from '~src/store/app/actions';

import { SBContainer } from './snackbarNotifications.sc';
import SnackbarItem from './SnackbarItem';
import {ThunkMWDispatch} from "~src/services/apiMiddleware";

export type SbPositionT = 'topLeft' | 'top' | 'topRight' | 'bottomLeft' | 'bottom' | 'bottomRight';

interface StateProps {
  notifications: NotificationI[];
  notificationsPosition: SbPositionT | undefined;
}

interface DispatchProps {
  removeNotification(id: string): void;
}

type Props = StateProps & DispatchProps;

const animationTimeout = 400;

const SnackbarNotifications: FC<Props> = (props) => {
  const { notificationsPosition = 'bottom' } = props;
  const removeItem = (id: string) => {
    props.removeNotification(id);
  };
  const [t] = useTranslation();
  const position = notificationsPosition.indexOf('top') !== -1 ? 'top' : 'bottom';

  return (
    <SBContainer className={props.notificationsPosition}>
      <TransitionGroup component={null}>
        {props.notifications.map(item => (
          <CSSTransition key={item.id || item.txtKey} timeout={animationTimeout}>
            <SnackbarItem
              position={position}
              id={item.id}
              txtKey={item.txtKey}
              txt={t(item.txtKey, item.txtProps)}
              persistent={item.persistent}
              type={item.type}
              iconName={item.iconName}
              removeItem={removeItem}
              animationTimeout={animationTimeout}
            />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </SBContainer>
  );
};

const mapState2Props = ({ app }: StoreI): StateProps => ({
  notifications: app.notifications,
  notificationsPosition: app.settings.notificationsPosition,
});

const mapDispatch2Props = (dispatch: ThunkMWDispatch): DispatchProps => ({
  removeNotification: id => dispatch(removeNotification(id)),
});

export default connect(mapState2Props, mapDispatch2Props)(SnackbarNotifications);
